import styled from 'styled-components';

export const ButtonLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
